import React from "react";
import { useTheme } from "@homesusa/layout";
import { brandFontFaces } from "./brand-fonts.styles";

export function BrandFonts(): JSX.Element | null {
  const { variant } = useTheme();
  return variant === "new" ? (
    <style id="usermanagement-brand-fonts">{brandFontFaces}</style>
  ) : null;
}
